module.exports = __webpack_public_path__ + "img/mrdoc.975c7029.png";